export const workCardStyles = {
  color: "#004A55",
  backgroundColor: "#F5F5F5",
  margin: "1rem 0",
  width: "100%",
};

export const darkWorkCardStyles = {
  color: "white",
  backgroundColor: "#4e4e50",
  margin: "1rem 0",
  width: "100%",
};

export const workCardContentStyling = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "stretch",
  paddingBottom: "0.5rem",
};

export const workCardIconStyling = {
  margin: "0 1rem",
  height: "1.5rem",
};
